export default __webpack_public_path__ + "static/media/equity.4be26dc6.svg";